import React, { useEffect, useState, useContext } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import { getSponsors } from "./actions/api";
import { DraftStateProvider, sponsorsStore } from './store/';
import { actionTypes as sponsorActions } from "./reducers/sponsorsReducer";
import MockDraft from './views/mockDraft';
import RankingsBuilder from './views/rankingsBuilder';
import ReportsBuilder from './views/reportsBuilder';
import GlobalStyle from './styles/global';
import SavedReports from './views/reportsBuilder/savedReports';
import SavedRankings from './views/rankingsBuilder/savedRankings';
import SavedDrafts from './views/mockDraft/draftResults/savedDrafts';
import Footer from './components/footer';

function App() {

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { dispatch } = useContext(sponsorsStore);

  useEffect(()=>{

    async function fetchSponsors(){
      const sponsors = await getSponsors();
      if(sponsors){
        dispatch({type: sponsorActions.fetchSponsors, payload: sponsors});
      }
    }

    fetchSponsors();
  },[dispatch]);

  return (
    <>
      <GlobalStyle mobileMenuOpen={mobileMenuOpen}/>
      <input id="toggle-nav" type="checkbox" className="b-hidden" autoComplete="off" value={mobileMenuOpen} onChange={()=>setMobileMenuOpen(!mobileMenuOpen)}/>
      <Router>
        <Switch>
          <Route exact path="/mock-draft/:draftId?">
            <DraftStateProvider>
              <MockDraft />
            </DraftStateProvider>
          </Route>
          <Route exact path="/rankings-builder/:rankingId?">
              <RankingsBuilder />
          </Route>
          <Route exact path="/reports-builder/:reportId?">
            <ReportsBuilder />
          </Route>
          <Route path="/mock-drafts">
            <SavedDrafts />
          </Route>
          <Route path="/my-rankings">
            <SavedRankings/>
          </Route>
          <Route path="/my-reports">
            <SavedReports />
          </Route>
          <Route path="*">
            {/* Redirect to wp app 404 */}
          </Route>
        </Switch>
      </Router>
      <Footer />
    </>
  );
}

export default App;

/*

*/